<li class="{{type}}">
  <div class="color-main">
  <div class="color-marker" [style.background-color]="color">&nbsp;</div>
  <p>
    <span class="title" (click)="onSelect($event)">{{title}}</span>
    <span class ="subtitle" [hidden]="subtitle==''">{{subtitle}}</span>
  </p>
  </div>
  <div class="color-selectors">
  <core-helpers-forms-select-color
    [colorSelected]="color"
    [colors]="colorOptions"
    [disabled]="type == 'inactive' ? true:false"
    (colorSelectedChange)="type != 'inactive'? select($event):''"
  ></core-helpers-forms-select-color>
  <span class="action" [hidden]="actionText==''" (click)="onAction($event)">{{actionText}}</span>
  </div>
</li>
